import { render, staticRenderFns } from "./ThirdPayConfig.vue?vue&type=template&id=c713d3e4&scoped=true"
import script from "./ThirdPayConfig.vue?vue&type=script&lang=js"
export * from "./ThirdPayConfig.vue?vue&type=script&lang=js"
import style0 from "./ThirdPayConfig.vue?vue&type=style&index=0&id=c713d3e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c713d3e4",
  null
  
)

export default component.exports